// extracted by mini-css-extract-plugin
export default {"inputGrid":"ayaYjzfCMsgWi_8uDN6Q","inputGridPartner":"pUIwi4lxi1DItXYkut78"};